import styled, {css} from 'styled-components'
import FrameBox from '../FrameBox'

export const Box = styled(FrameBox)`
  bottom: 20px;
  left: 50%;
  transition: all 0.25s ease-in-out;
`

export const MenuList = styled.ul`
  float: left;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 0;
`

export const MenuElement = styled.li`
  position: relative;
  float: left;
  padding-left: 10px;
  margin-left: 10px;

  & + li:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 1px;
    height: 38px;
    background: #c5c5c5;
    z-index: 1;
  }

  &:last-child {
    padding-right: 10px;
    margin-right: 10px;
  }
`

export const Action = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 38px;
  padding: 0 10px;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 500;
  overflow: hidden;

  background: none;
  border: none;
  outline: none;

  color: ${props => (props.isSelected ? props.theme.colors.hover : 'inherit')};

  &:hover {
    color: ${props => props.theme.colors.hover};
    cursor: pointer;
  }

  & > i.fa,
  & > svg {
    font-size: 16px;
    margin-right: 10px;
  }
`



// WEBPACK FOOTER //
// ./src/components/FrameMenu/theme.js